<template>
  <div>
    <div>
      <!-- <el-select placeholder="审核状态" v-model="status" clearable>
          <el-option value="-1" label="全部"></el-option>
        <el-option value="0" label="待审核"></el-option>
        <el-option value="1" label="审核不通过"></el-option>
        <el-option value="2" label="审核通过"></el-option>
      </el-select> -->
      <el-input
      clearable
        style="width: 200px"
        placeholder="信息筛选"
        v-model="username"
      ></el-input>
      <el-button @click="getpage(1)">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list">
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="realName" label="真实姓名"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
         <el-table-column prop="orgName" label="机构"></el-table-column>
         <el-table-column prop="department" label="科室"></el-table-column>
        <el-table-column prop="subject" label="学科"></el-table-column>

        <el-table-column label="状态" 
        :filters="[{ text: '待审核', value: 0 },{ text: '审核通过', value: 1 }, { text: '审核未通过', value: 2 }]"
        :filter-method="filterTag"
        
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.status == 0
                  ? 'primary'
                  : scope.row.status == 2
                  ? 'danger'
                  : 'success'
              "
              >{{
                scope.row.status == 0
                  ? "待审核"
                  : scope.row.status == 2
                  ? "未通过"
                  : "通过"
              }}</el-tag
            >
          </template>
        </el-table-column>
                <el-table-column prop="reviewer" label="审核人"></el-table-column>
  <el-table-column prop="remark" label="审核人备注"></el-table-column>
        <el-table-column align="center" label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleApply(scope.$index, scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
    <!-- 审核 -->
    <el-dialog title="审核" :visible.sync="visible" width="500px">
      <div>
        <label style="width:100px;display:inline-block">审核是否通过：</label>
        <el-radio size="small" v-model="pass.status" :label="1" border
          >是</el-radio
        >
        <el-radio size="small" v-model="pass.status" :label="2" border
          >否</el-radio
        >
      </div>
      <div style="margin-top:10px;">
        <label style="width:100px;display:inline-block;line-height:54px">备注：</label>
        <el-input
          type="textarea"
          style="width:300px"
          :autosize="{ minRows: 2, maxRows: 2 }"
          placeholder="请输入备注"
          v-model="pass.remark"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="passCheck"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import page from "../../components/pages";
export default {
  components: {
    page,
  },
  mounted() {
    this.load();
  },
  data() {
    return {
      visible: false,
      username: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      status: "",
      pass: {
        id: "",
        remark: "",
        status: "1",
      },
    };
  },
  methods: {
    filterTag(value, row) {
      // console.log(value,row)
        return row.status === value;
      },
    passCheck() {
      this.$api.registerApply(this.pass).then(res=>{
        console.log(res)
         if(res.data.code==200){
               this.$message({
                 message:'审核成功',
                 type:'success'
               })
               this.visible=false
               this.load()
               }
      })
    },
    //获取医院code
    treeall(x) {
      this.pass.id = x.id;
    },

    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        search: this.username,
      };
      // if(this.status!=-1){
      //   obj.status=this.status
      // }
      // console.log(obj);
      this.$api.registerList(obj).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    handleApply(index, row) {
      // console.log(index, row);
      this.pass.id = row.id;
      this.pass.remark=row.remark
      this.pass.status = row.status;
      this.visible = true;
    },
    getpage(x) {
      //分页
      // console.log(x);
      this.page = x;
      this.load();
    },
  },
};
</script>

<style scoped>
</style>